export default function MCCalcPreviewPanel({ title = 'Preview de cálculo', values = [] }) {
  return (
    <aside className="sticky top-20 rounded-lg border border-gray-200 bg-white p-4 space-y-2">
      <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      {values.length === 0 ? (
        <p className="text-xs text-gray-500">Sin datos para previsualizar.</p>
      ) : (
        values.map((item) => (
          <div key={item.label} className="flex justify-between text-xs">
            <span className="text-gray-600">{item.label}</span>
            <span className="font-semibold text-gray-900">{item.value}</span>
          </div>
        ))
      )}
    </aside>
  )
}
